import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
    width: "15",
    height: "14",
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var _hoisted_2 = ["fill"];
export default /*@__PURE__*/ _defineComponent({
    __name: 'ClockIcon',
    props: {
        color: {
            type: String,
            required: true
        }
    },
    setup: function (__props) {
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
                _createElementVNode("path", {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d: "M7.58431 12.8332C4.36431 12.8332 1.75098 10.2257 1.75098 6.99984C1.75098 3.77984 4.36431 1.1665 7.58431 1.1665C10.8101 1.1665 13.4176 3.77984 13.4176 6.99984C13.4176 10.2257 10.8101 12.8332 7.58431 12.8332ZM9.4447 9.16394C9.5147 9.20477 9.59053 9.22811 9.6722 9.22811C9.81803 9.22811 9.96386 9.15227 10.0455 9.01227C10.168 8.80811 10.1039 8.53977 9.89386 8.41144L7.8172 7.17477V4.47977C7.8172 4.23477 7.61886 4.04227 7.3797 4.04227C7.14053 4.04227 6.9422 4.23477 6.9422 4.47977V7.42561C6.9422 7.57727 7.02386 7.71727 7.15803 7.79894L9.4447 9.16394Z",
                    fill: __props.color
                }, null, 8, _hoisted_2)
            ]));
        };
    }
});
